module.exports = __webpack_public_path__ + "img/3-1.5da3f1ce.png";